export default __webpack_public_path__ + "assets/10c2022c836a4641e45d91fceef94cf2.png";